import React from "react";
import { useNavigate } from "react-router-dom";

const ThighBackPT = () => {
  const navigate = useNavigate();

  return (
    <>
      <style>{`
        .tbb-page {
          min-height: 100vh;
          width: 100%;
          background: radial-gradient(circle at top left, #fefce8 0, #f9fafb 40%, #e5e7eb 100%);
          font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
          color: #0f172a;
        }

        .tbb-inner {
          max-width: 1200px;
          margin: 0 auto;
          padding: 32px 16px 72px;
        }

        /* HERO */
        .tbb-hero {
          padding: 26px 22px 34px;
          border-radius: 28px;
          background: linear-gradient(120deg, rgba(234, 179, 8, 0.25), rgba(248, 250, 252, 0.7));
          margin-bottom: 36px;
          display: grid;
          grid-template-columns: minmax(0, 1.5fr) minmax(0, 1.1fr);
          gap: 24px;
          align-items: center;
        }

        @media (max-width: 820px) {
          .tbb-hero {
            grid-template-columns: 1fr;
          }
        }

        .tbb-tag {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          padding: 5px 12px;
          border-radius: 999px;
          background: rgba(234, 179, 8, 0.25);
          color: #854d0e;
          font-size: 12px;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.08em;
          margin-bottom: 8px;
        }

        .tbb-tagDot {
          width: 6px;
          height: 6px;
          border-radius: 999px;
          background: #eab308;
        }

        .tbb-title {
          font-size: clamp(28px, 4vw, 38px);
          font-weight: 800;
          line-height: 1.1;
          margin-bottom: 10px;
        }

        .tbb-subtitle {
          font-size: 15px;
          max-width: 560px;
          color: #374151;
        }

        .tbb-chips {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
          margin: 16px 0 18px;
        }

        .tbb-chip {
          padding: 6px 12px;
          border-radius: 999px;
          background: #0f172a;
          color: #f9fafb;
          font-size: 11px;
        }

        .tbb-ctaRow {
          display: flex;
          flex-wrap: wrap;
          gap: 10px;
          margin-top: 10px;
        }

        .tbb-btnPrimary,
        .tbb-btnSecondary {
          border-radius: 999px;
          border: none;
          font-size: 14px;
          padding: 9px 18px;
          cursor: pointer;
          display: inline-flex;
          align-items: center;
          gap: 6px;
          transition: transform 0.12s ease, box-shadow 0.12s ease, background 0.12s ease;
        }

        .tbb-btnPrimary {
          background: #eab308;
          color: #0f172a;
          box-shadow: 0 10px 24px rgba(234, 179, 8, 0.4);
        }

        .tbb-btnPrimary:hover {
          transform: translateY(-1px);
          box-shadow: 0 14px 32px rgba(234, 179, 8, 0.55);
        }

        .tbb-btnSecondary {
          background: rgba(15, 23, 42, 0.06);
          color: #111827;
          border: 1px solid rgba(148, 163, 184, 0.7);
        }

        .tbb-btnSecondary:hover {
          background: rgba(15, 23, 42, 0.1);
          transform: translateY(-1px);
        }

        .tbb-heroImgWrap {
          display: flex;
          justify-content: center;
        }

        .tbb-heroImg {
          width: 100%;
          max-width: 380px;
          border-radius: 24px;
          object-fit: cover;
          box-shadow: 0 18px 38px rgba(15, 23, 42, 0.24);
        }

        /* GENERIC SECTIONS */
        .tbb-stripe {
          padding: 32px 0;
          border-bottom: 1px solid rgba(148, 163, 184, 0.35);
        }

        .tbb-sectionTitle {
          font-size: 21px;
          font-weight: 800;
          margin-bottom: 8px;
        }

        .tbb-sectionSubtitle {
          font-size: 14px;
          color: #4b5563;
          margin-bottom: 18px;
        }

        .tbb-flexRow {
          display: flex;
          flex-wrap: wrap;
          gap: 24px;
          align-items: center;
        }

        .tbb-flexCol {
          flex: 1 1 260px;
        }

        .tbb-img {
          width: 100%;
          max-width: 360px;
          border-radius: 22px;
          object-fit: cover;
          box-shadow: 0 14px 30px rgba(15, 23, 42, 0.18);
        }

        /* LISTS */
        .tbb-list {
          list-style: none;
          padding: 0;
          margin: 0;
          display: grid;
          gap: 8px;
        }

        .tbb-list li {
          display: flex;
          gap: 8px;
          font-size: 14px;
          color: #111827;
        }

        .tbb-bullet {
          width: 7px;
          height: 7px;
          border-radius: 999px;
          background: #eab308;
          margin-top: 6px;
          flex-shrink: 0;
        }

        /* CARD GRID */
        .tbb-cardGrid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
          gap: 16px;
          margin-top: 18px;
        }

        .tbb-card {
          padding: 12px 14px;
          border-radius: 18px;
          background: rgba(15, 23, 42, 0.02);
          border: 1px solid rgba(148, 163, 184, 0.5);
        }

        .tbb-cardTitle {
          font-size: 13px;
          font-weight: 700;
          margin-bottom: 4px;
        }

        .tbb-cardText {
          font-size: 12px;
          color: #4b5563;
        }

        /* TWO-COLUMN GRID SECTION */
        .tbb-twoColGrid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
          gap: 20px;
          margin-top: 18px;
        }

        .tbb-pillBox {
          padding: 14px 14px;
          border-radius: 18px;
          background: rgba(15, 23, 42, 0.03);
        }

        .tbb-pillTitle {
          font-size: 13px;
          font-weight: 700;
          margin-bottom: 6px;
        }

        .tbb-pillText {
          font-size: 13px;
          color: #4b5563;
        }

        /* BANNER */
        .tbb-banner {
          position: relative;
          border-radius: 26px;
          overflow: hidden;
          margin-top: 24px;
        }

        .tbb-banner img {
          width: 100%;
          height: 240px;
          object-fit: cover;
          display: block;
        }

        @media (min-width: 768px) {
          .tbb-banner img {
            height: 270px;
          }
        }

        .tbb-bannerOverlay {
          position: absolute;
          inset: 0;
          background: linear-gradient(90deg, rgba(15, 23, 42, 0.82), transparent 60%);
          display: flex;
          flex-direction: column;
          justify-content: center;
          padding: 18px 20px;
          gap: 10px;
        }

        .tbb-bannerText {
          color: #fefce8;
          font-size: 15px;
          max-width: 420px;
        }

        .tbb-bannerButtons {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
        }

        .tbb-bannerButtons button {
          font-size: 12px;
          padding: 8px 14px;
          border-radius: 999px;
          border: none;
          cursor: pointer;
        }

        .tbb-bannerButtons .primary {
          background: #eab308;
          color: #0f172a;
        }

        .tbb-bannerButtons .secondary {
          background: rgba(255,255,255,0.18);
          color: #f9fafb;
          border: 1px solid rgba(255,255,255,0.6);
        }

        /* BOTTOM STRIP */
        .tbb-bottomStrip {
          margin-top: 24px;
          padding: 14px 14px;
          border-radius: 22px;
          background: #0f172a;
          display: flex;
          flex-wrap: wrap;
          gap: 12px;
          align-items: center;
          justify-content: space-between;
        }

        .tbb-bottomText {
          font-size: 12px;
          color: #e5e7eb;
          flex: 1 1 240px;
        }

        .tbb-bottomText strong {
          color: #fef9c3;
        }

        .tbb-bottomActions {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
        }

        .tbb-bottomActions button {
          font-size: 12px;
          padding: 7px 12px;
          border-radius: 999px;
          border: none;
          cursor: pointer;
        }

        .tbb-bottomActions .primary {
          background: #eab308;
          color: #0f172a;
        }

        .tbb-bottomActions .secondary {
          background: transparent;
          color: #e5e7eb;
          border: 1px solid rgba(148, 163, 184, 0.8);
        }

        @media (max-width: 640px) {
          .tbb-title {
            font-size: 26px;
          }
        }
      `}</style>

      <div className="tbb-page">
        <div className="tbb-inner">
          {/* HERO */}
          <section className="tbb-hero">
            <div>
              <div className="tbb-tag">
                <span className="tbb-tagDot" />
                Back Thigh · Hamstrings
              </div>
              <h1 className="tbb-title">
                Help your hamstrings feel less tight and more powerful, not fragile.
              </h1>
              <p className="tbb-subtitle">
                The hamstrings—biceps femoris, semitendinosus, and semimembranosus—control how you bend your knee,
                extend your hip, and decelerate your leg when you walk, run, or climb. When they&apos;re irritated,
                they can feel tight, grabby, or sharp with certain moves.
              </p>

              <div className="tbb-chips">
                <span className="tbb-chip">Back-of-thigh tightness</span>
                <span className="tbb-chip">Hamstring strain history</span>
                <span className="tbb-chip">Pain with bending or sprinting</span>
                <span className="tbb-chip">“Pulled muscle” feeling</span>
              </div>

              <div className="tbb-ctaRow">
                <button
                  className="tbb-btnPrimary"
                  onClick={() => navigate("/appointments")}
                >
                  Book a hamstring visit →
                </button>
                <button
                  className="tbb-btnSecondary"
                  onClick={() => navigate("/staff")}
                >
                  Meet our therapists
                </button>
              </div>
            </div>

            <div className="tbb-heroImgWrap">
              <img
                src="/content/thigh-back/thigh_back_hero.png"
                alt="Therapist assessing back of thigh and hamstrings"
                className="tbb-heroImg"
              />
            </div>
          </section>

          {/* WHAT CAN GO WRONG */}
          <section className="tbb-stripe">
            <div className="tbb-sectionTitle">What can go wrong in the back of the thigh?</div>
            <p className="tbb-sectionSubtitle">
              Hamstrings help you control your leg during walking, running, jumping, and bending. When they&apos;re
              stressed or not well-supported by the hips and core, they can complain with tightness or pain.
            </p>

            <div className="tbb-flexRow">
              <div className="tbb-flexCol">
                <ul className="tbb-list">
                  <li>
                    <span className="tbb-bullet" />
                    <span>
                      A sudden “pull” or sharp pain in the back of the thigh with a sprint, quick step, or slip.
                    </span>
                  </li>
                  <li>
                    <span className="tbb-bullet" />
                    <span>
                      Ongoing tightness that doesn&apos;t seem to resolve with stretching alone.
                    </span>
                  </li>
                  <li>
                    <span className="tbb-bullet" />
                    <span>
                      Soreness at the back of the knee or up near the sit-bone after activity.
                    </span>
                  </li>
                  <li>
                    <span className="tbb-bullet" />
                    <span>
                      Hesitation or fear with returning to running, sports, or gym work because of past strains.
                    </span>
                  </li>
                </ul>

                <div className="tbb-ctaRow" style={{ marginTop: "14px" }}>
                  <button
                    className="tbb-btnPrimary"
                    onClick={() => navigate("/appointments")}
                  >
                    See if this sounds like you →
                  </button>
                  <button
                    className="tbb-btnSecondary"
                    onClick={() => navigate("/contact")}
                  >
                    Ask a quick question
                  </button>
                </div>
              </div>

              <div className="tbb-flexCol" style={{ display: "flex", justifyContent: "center" }}>
                <img
                  src="/content/thigh-back/thigh_back_hamstrings_manual.png"
                  alt="Manual therapy along hamstring muscle group"
                  className="tbb-img"
                />
              </div>
            </div>

            <div className="tbb-cardGrid">
              <div className="tbb-card">
                <div className="tbb-cardTitle">Biceps Femoris</div>
                <div className="tbb-cardText">
                  Hamstring muscle on the outer back of the thigh, important for knee flexion and hip extension.
                </div>
              </div>
              <div className="tbb-card">
                <div className="tbb-cardTitle">Semitendinosus</div>
                <div className="tbb-cardText">
                  More central hamstring that helps bend the knee and control leg motion during gait.
                </div>
              </div>
              <div className="tbb-card">
                <div className="tbb-cardTitle">Semimembranosus</div>
                <div className="tbb-cardText">
                  Deeper hamstring near the inner back of the thigh, often involved in high hamstring pain.
                </div>
              </div>
            </div>
          </section>

          {/* STRETCHING / FLEXIBILITY */}
          <section className="tbb-stripe">
            <div className="tbb-flexRow">
              <div className="tbb-flexCol">
                {/* NOTE: this one is JPG on purpose */}
                <img
                  src="/content/thigh-back/thigh_back_stretching.jpg"
                  alt="Therapist assisting hamstring stretch"
                  className="tbb-img"
                />
              </div>

              <div className="tbb-flexCol">
                <div className="tbb-sectionTitle">Why stretching alone isn&apos;t always enough</div>
                <p className="tbb-sectionSubtitle">
                  Tight hamstrings can be a sign they&apos;re working overtime to protect the area, not just that
                  they&apos;re “short.” PT looks at the full picture.
                </p>

                <ul className="tbb-list">
                  <li>
                    <span className="tbb-bullet" />
                    <span>
                      Gentle, guided stretches that respect your current healing phase and comfort.
                    </span>
                  </li>
                  <li>
                    <span className="tbb-bullet" />
                    <span>
                      Checking how your back, hips, and calves share the work of bending and walking.
                    </span>
                  </li>
                  <li>
                    <span className="tbb-bullet" />
                    <span>
                      Making sure you&apos;re not overstretching an area that still needs support.
                    </span>
                  </li>
                </ul>

                <div className="tbb-ctaRow" style={{ marginTop: "14px" }}>
                  <button
                    className="tbb-btnPrimary"
                    onClick={() => navigate("/appointments")}
                  >
                    Start a hamstring-friendly plan →
                  </button>
                </div>
              </div>
            </div>
          </section>

          {/* HOW PT HELPS */}
          <section className="tbb-stripe">
            <div className="tbb-sectionTitle">How physical therapy supports your hamstrings</div>
            <p className="tbb-sectionSubtitle">
              We look at strength, control, flexibility, and how your whole leg and trunk work together, not just one muscle.
            </p>

            <div className="tbb-twoColGrid">
              <div className="tbb-pillBox">
                <div className="tbb-pillTitle">Calm things down</div>
                <div className="tbb-pillText">
                  Hands-on techniques and position changes to reduce sensitivity and protect healing tissue.
                </div>
              </div>
              <div className="tbb-pillBox">
                <div className="tbb-pillTitle">Rebuild strength</div>
                <div className="tbb-pillText">
                  Gradual hamstring loading—starting with easy positions and progressing as your leg tolerates more.
                </div>
              </div>
              <div className="tbb-pillBox">
                <div className="tbb-pillTitle">Improve control</div>
                <div className="tbb-pillText">
                  Exercises that train your hamstrings, glutes, and core to share the work of running, bending, and lifting.
                </div>
              </div>
              <div className="tbb-pillBox">
                <div className="tbb-pillTitle">Return to your sport or routine</div>
                <div className="tbb-pillText">
                  A stepwise plan for returning to walking, gym, or sports with fewer “is it going to pull again?” worries.
                </div>
              </div>
            </div>

            <div className="tbb-ctaRow" style={{ marginTop: "18px" }}>
              <button
                className="tbb-btnPrimary"
                onClick={() => navigate("/appointments")}
              >
                Book a hamstring session →
              </button>
              <button
                className="tbb-btnSecondary"
                onClick={() => navigate("/insurance")}
              >
                Check my insurance
              </button>
            </div>
          </section>

          {/* EXERCISES / VISIT FLOW */}
          <section className="tbb-stripe">
            <div className="tbb-flexRow">
              <div className="tbb-flexCol">
                <img
                  src="/content/thigh-back/thigh_back_strengthening.png"
                  alt="Patient doing hamstring strengthening with therapist"
                  className="tbb-img"
                />
              </div>

              <div className="tbb-flexCol">
                <div className="tbb-sectionTitle">What a back thigh / hamstring visit may look like</div>

                <div className="tbb-twoColGrid">
                  <div className="tbb-pillBox">
                    <div className="tbb-pillTitle">1. Your story</div>
                    <div className="tbb-pillText">
                      We talk about when it started, what you were doing, and what you&apos;re hoping to get back to.
                    </div>
                  </div>
                  <div className="tbb-pillBox">
                    <div className="tbb-pillTitle">2. Motion & strength check</div>
                    <div className="tbb-pillText">
                      Gentle tests of hamstring strength, flexibility, and how your hip and back participate.
                    </div>
                  </div>
                  <div className="tbb-pillBox">
                    <div className="tbb-pillTitle">3. Hands-on care</div>
                    <div className="tbb-pillText">
                      You try specific manual techniques, stretches, or positions that may ease discomfort.
                    </div>
                  </div>
                  <div className="tbb-pillBox">
                    <div className="tbb-pillTitle">4. Simple home plan</div>
                    <div className="tbb-pillText">
                      You leave with a small set of realistic exercises you can repeat between visits.
                    </div>
                  </div>
                </div>

                <div className="tbb-ctaRow" style={{ marginTop: "16px" }}>
                  <button
                    className="tbb-btnPrimary"
                    onClick={() => navigate("/appointments")}
                  >
                    Book a hamstring evaluation →
                  </button>
                </div>
              </div>
            </div>
          </section>

          {/* BANNER */}
          <section className="tbb-stripe">
            <div className="tbb-banner">
              <img
                src="/content/thigh-back/thigh_back_banner.png"
                alt="Bright PT clinic for hamstring and leg care"
              />
              <div className="tbb-bannerOverlay">
                <div className="tbb-bannerText">
                  Hamstring sessions happen in a calm, one-on-one environment where we match your plan
                  to your comfort level, sport, and daily routine.
                </div>
                <div className="tbb-bannerButtons">
                  <button
                    className="primary"
                    onClick={() => navigate("/appointments")}
                  >
                    Schedule a back thigh visit →
                  </button>
                  <button
                    className="secondary"
                    onClick={() => navigate("/office")}
                  >
                    View locations
                  </button>
                </div>
              </div>
            </div>
          </section>

          {/* SAFETY NOTE */}
          <section className="tbb-stripe">
            <div className="tbb-bottomStrip">
              <div className="tbb-bottomText">
                If you notice sudden severe thigh pain with a popping sensation, can&apos;t bear weight,
                see a large bruise or deformity, or have significant swelling and weakness,{" "}
                <strong>seek medical or urgent care first.</strong> Physical therapy can then help guide your
                return to activity once serious injury is ruled out.
              </div>
              <div className="tbb-bottomActions">
                <button
                  className="primary"
                  onClick={() => navigate("/appointments")}
                >
                  Schedule hamstring PT
                </button>
                <button
                  className="secondary"
                  onClick={() => navigate("/contact")}
                >
                  Message our team
                </button>
              </div>
            </div>
          </section>

        </div>
      </div>
    </>
  );
};

export default ThighBackPT;
